import { z } from "zod";

/** PUT declares the aisle break after that bay of the store's fixtures; DELETE joins the two bays. */
export const RouteCategories_categoryId_Stores_storeId_AisleBreaks_afterBayNo_ =
  "/categories/:categoryId/stores/:storeId/aisle-breaks/:afterBayNo";

export const RoutePutCategories_categoryId_Stores_storeId_AisleBreaks_afterBayNo_ =
  RouteCategories_categoryId_Stores_storeId_AisleBreaks_afterBayNo_;

export const RouteDeleteCategories_categoryId_Stores_storeId_AisleBreaks_afterBayNo_ =
  RouteCategories_categoryId_Stores_storeId_AisleBreaks_afterBayNo_;

/** `afterBayNo` is 1-based, numbered the way the fixtures pog numbers its bays. */
export const ParamsCategoriesStoresAisleBreakSchema = z.object({
  categoryId: z.coerce.number().int().positive(),
  storeId: z.coerce.number().int().positive(),
  afterBayNo: z.coerce.number().int().positive(),
});

export type ParamsCategories_categoryId_Stores_storeId_AisleBreaks_afterBayNo_ = z.infer<
  typeof ParamsCategoriesStoresAisleBreakSchema
>;

/** Who wrote the break: the fixture file, or someone in the app. */
export const AisleBreakSourceSchema = z.enum(["declared_csv", "declared_ui"]);

export type AisleBreakSource = z.infer<typeof AisleBreakSourceSchema>;

export const AisleBreakSchema = z.object({
  afterBayNo: z.number().int().positive(),
  source: AisleBreakSourceSchema,
});

export type AisleBreak = z.infer<typeof AisleBreakSchema>;

/** Every break the store's fixtures declare after the call, in bay order. */
export const ResponseAisleBreaksSchema = z.object({
  aisle_breaks: z.array(AisleBreakSchema),
});

export type ResponsePutCategories_categoryId_Stores_storeId_AisleBreaks_afterBayNo_ = z.infer<
  typeof ResponseAisleBreaksSchema
>;

export type ResponseDeleteCategories_categoryId_Stores_storeId_AisleBreaks_afterBayNo_ = z.infer<
  typeof ResponseAisleBreaksSchema
>;
